import { LitElement, css, html } from 'lit';

import { customElement } from 'lit/decorators';

@customElement('admin-points-upload-fragment')
export class AdminPointsUploadFragment extends LitElement {

    protected render() {
        return html`
            <div id="container">
                <h2 class="title">Add Points Faster</h2>
                <p class="info-paragraph">
                    With our bulk add feature and upload capabilities, you can add points faster
                    than ever.
                </p>
                <kml-upload-component
                    bypassGoogleKey>
                </kml-upload-component>
                <hr />
                <p class="addon__footer">
                    If you have any questions, or need help, reach out to
                    <a href="mailto:help@proxi.co">help@proxi.co</a>.
                </p>
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            #container {
                flex-direction: column;
                max-height: calc(100vh - 108px);
                overflow: hidden auto;
                margin-bottom: 1rem;
                padding-right: 30px;
            }

            /* width */
            #container::-webkit-scrollbar {
                width: 5px;
            }

            /* Track */
            #container::-webkit-scrollbar-track {
                background: var(--theme-light-scrollbar-color);
            }

            /* Handle */
            #container::-webkit-scrollbar-thumb {
                background: var(--main-moon-color);
            }

            .helpHeader {
                color: var(--main-primary-color);
            }

            .title {
                color: var(--main-primary-color);
                text-align: center;
                font-size: 18px;
                font-weight: 700;
                line-height: 130%;
                margin: 5px 0;
                text-align: left;
            }

            .info-paragraph {
                color: var(--theme-input-color);
                margin-top: 0;
                margin-bottom: 0;
            }

            .sub-title {
                margin-bottom: 5px;
                color: var(--theme-input-color);
            }

            .addon__footer {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                padding: 0 20px;
                gap: 10px;
            }

            @media only screen and (max-width: 550px) {
                .helpHeader {
                    margin: 0.2em 0;
                }
            }
        `;
    }
}
